import { FC } from "react"
import { EventId } from "@app/data/eventDetails/types"
import s from "@pages/fid_view/styles.module.css"
import HeaderContent from "@pages/fid_view/components/HeaderContent"
import PhotoGallery from "@pages/fid_view/components/PhotoGallery"
import classNames from "classnames"
import { DetailedEventInSearchDto } from "@app/data/tribeSwaggerApi"

export interface EventHeaderProps {
  id?: EventId
  eventPhoto?: string[]
  eventTitle?: string
  eventInfo?: DetailedEventInSearchDto
}

const EventHeader: FC<EventHeaderProps> = ({ eventInfo }) => {
  if (!eventInfo) return null
  const photos = eventInfo?.event_photo ?? []

  if (photos.length === 0) {
    return (
      <div className={s.container}>
        <div className={classNames(s.header_content, s.header_content_no_photo)}>
          <HeaderContent eventInfo={eventInfo} title={eventInfo.event_name} />
        </div>
      </div>
    )
  }

  return (
    <PhotoGallery photos={photos}>
      <div className={s.container}>
        {/* Название и кнопки — под фото, обычным цветом текста, чтобы читались на любой картинке */}
        <div className={classNames(s.header_content, s.header_content_no_photo)}>
          <HeaderContent eventInfo={eventInfo} title={eventInfo.event_name} />
        </div>
      </div>
    </PhotoGallery>
  )
}

export default EventHeader
